import * as React from "react";
import { forwardRef } from "react";
const WechatIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  "data-category": "brands",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fill: "#2DC100",
  d: "M16.6739 8.45748c-2.2277.11686-4.1655.79132-5.738 2.31782-1.58906 1.5412-2.31413 3.4303-2.1163 5.772-.87045-.1076-1.6636-.2263-2.46136-.2935-.27512-.023-.60269.0101-.83549.1417-.77475.4371-1.5173.9303-2.39695 1.4805.16194-.7306.26592-1.3701.45086-1.9847.13618-.4518.0727-.7039-.34321-.9984C.558618 13.0048-.568549 10.1791.275216 7.26959 1.05549 4.57819 2.97306 2.94587 5.57704 2.09474c3.55541-1.161209 7.54976.02301 9.71206 2.84599.7803 1.01951 1.2596 2.16415 1.3857 3.51675zM6.41989 7.55115c.02024-.53184-.44075-1.01123-.98823-1.02779-.56036-.01656-1.02227.41222-1.03791.9643-.01657.56036.41222 1.00847.97626 1.02319.55944.0138 1.02963-.41498 1.04988-.9597m5.34971-1.02779c-.5494.01012-1.014.47847-1.0048 1.01215.0101.55392.4656.9873 1.0305.97994.5668-.00644.9965-.44442.991-1.01031-.0046-.55484-.4582-.99282-1.0177-.9827z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2DC100",
  d: "M21.6795 22.3478c-.7057-.3138-1.3526-.7858-2.0418-.8576-.6864-.0717-1.4078.3239-2.1255.3975-2.1871.2236-4.147-.3855-5.7628-1.8798-3.07325-2.8423-2.63343-7.2001.9211-9.5299 3.1597-2.07027 7.7935-1.38017 10.0221 1.4925 1.9442 2.5064 1.716 5.8337-.6579 7.9389-.6864.6092-.934 1.1106-.4932 1.9139.081.1482.0902.3359.138.5236zm-8.03-7.7752c.449 0 .8189-.3515.8355-.795.0184-.4692-.3598-.863-.83-.8658-.4656-.0018-.8557.3975-.8392.8603.0157.4417.3874.7996.8337.8005m5.1767-1.658c-.4362-.0028-.8061.3533-.8235.794-.0194.4711.3468.8576.8134.8585.4508.0019.8069-.3395.8235-.7876.0175-.472-.3488-.8613-.8125-.8649z"
}));
const ForwardRef = forwardRef(WechatIcon);
ForwardRef.category = "brands";
export { ForwardRef as WechatIcon };